import Vue from 'vue';
import Router from 'vue-router';
// import paths from './paths';
import paths from './paths_eureka';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from './../store';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const currentUser = store.state.login.currentUser;

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (to.path === '/login' && currentUser) {
    NProgress.start();
    next('/dashboard');
  } else {
    NProgress.start();
    next();
  }
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js